import { render } from "./TvmServiceOffers.vue?vue&type=template&id=041058cc&scoped=true"
import script from "./TvmServiceOffers.js?vue&type=script&lang=js&external"
export * from "./TvmServiceOffers.js?vue&type=script&lang=js&external"

import "./TvmServiceOffers.vue?vue&type=style&index=0&id=041058cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041058cc"],['__file',"src/Components/ChatWidget/TvmServiceOffers/TvmServiceOffers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "041058cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('041058cc', __exports__)) {
    api.reload('041058cc', __exports__)
  }
  
  module.hot.accept("./TvmServiceOffers.vue?vue&type=template&id=041058cc&scoped=true", () => {
    api.rerender('041058cc', render)
  })

}


export default __exports__